import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { LazyLoadEvent } from 'primeng/primeng';
import { IntegrixEncoderUtils } from "../../shared/utils/integrixEncoderUtils";
import 'rxjs/add/operator/map'

import { Usuario } from './usuario';
import { ChangePassword } from '../../shared/layout/header/change-password/changePassword';

import { BodyService} from "../../shared/utils/body.service";
import { BaseService} from "../../shared/utils/BaseService";
import { PageResponse, PageRequestByExample } from '../../shared/utils/pagingNormal';
import {Maestro} from "../_maestro/maestro";

@Injectable()
export class UsuarioService extends BaseService{

    constructor(protected http: Http,
                protected bodyService: BodyService) {
        super(http, bodyService);
    }

    getAllPaging(usuario : Usuario, event : LazyLoadEvent) : Observable<PageResponse<Usuario>> {
    let request = new PageRequestByExample(usuario, event);
    let body = JSON.stringify(request);
    return this.http.post(this.rutaServidor + '/api/usuarios/page', body, this.options)
        .map(response => {
            let bodyResponse = response.json();
            if (bodyResponse) {
                let jsonResponse : any = response.json();
                let page : PageResponse<Usuario> =
                    new PageResponse<Usuario>(jsonResponse.totalPages, jsonResponse.totalElements, Usuario.toArray(jsonResponse.content));
                return page;
            } else {
                return {}
            }

        })
        .catch(this.bodyService.handleError);
    }

    getAllPaging3(maestro : Usuario, event : LazyLoadEvent) : Observable<PageResponse<Usuario>> {
        let request = new PageRequestByExample(maestro, event);
        let body = JSON.stringify(request);
        return this.http.post(this.rutaServidor + '/api/usuarios/maestro/page2', body, this.options)
            .map(response => {
                let bodyResponse = response.json();
                debugger;
                if (bodyResponse) {
                    let jsonResponse : any = response.json();
                    let page : PageResponse<Usuario> =
                        new PageResponse<Usuario>(jsonResponse.totalPages, jsonResponse.totalElements, Usuario.toArray(jsonResponse.content));
                    return page;
                } else {
                    return {}
                }

            })
            .catch(this.bodyService.handleError);
    }

    getAllPaging2(usuario : Usuario, event : LazyLoadEvent) : Observable<PageResponse<Usuario>> {
        let request = new PageRequestByExample(usuario, event);
        let body = JSON.stringify(request);
        return this.http.post(this.rutaServidor + '/api/usuarios/page2', body, this.options)
            .map(response => {
                let bodyResponse = response.json();
                if (bodyResponse) {
                    let jsonResponse : any = response.json();
                    let page : PageResponse<Usuario> =
                        new PageResponse<Usuario>(jsonResponse.totalPages, jsonResponse.totalElements, Usuario.toArray(jsonResponse.content));
                    return page;
                } else {
                    return {}
                }

            })
            .catch(this.bodyService.handleError);
    }

    getById(id: string): Observable<Usuario>  {
        return this.http.get(this.rutaServidor + '/api/usuarios/' + id, this.options)
            .map(response => {
                let jsonResponse : any = response.json();
                return jsonResponse;
             })
            .catch(this.bodyService.handleError);
    }

    add(usuario: Usuario): Observable<any>  {
        usuario.passwordAnterior = usuario.password;
        usuario.usuarioRed = usuario.username;
        // usuario.password = IntegrixEncoderUtils.encriptar(usuario.password);
        let body = JSON.stringify(usuario);
        return this.http.post(this.rutaServidor + '/api/usuarios/', body, this.options)
            .map(response => {
                let bodyResponse = response.json();
                if (bodyResponse) {
                  let usuarioResponse =  response.json();
                  return usuarioResponse;
                } else {
                  return {}
                }
             })
            .catch(this.bodyService.handleError);
    }

    update(usuario: Usuario): Observable<any>  {
        if(usuario.password.length >0){
            usuario.passwordAnterior = usuario.password;
            // usuario.password = IntegrixEncoderUtils.encriptar(usuario.password);
        }
        usuario.usuarioRed = usuario.username;        
        let body = JSON.stringify(usuario);
        return this.http.put(this.rutaServidor + '/api/usuarios/', body, this.options)
            .map(response => {
                let bodyResponse = response.json();
                if (bodyResponse) {
                  let usuarioResponse = response.json();
                  return usuarioResponse;
                } else {
                  return {}
                }
             })
            .catch(this.bodyService.handleError);
    }

    delete(id: string): any{
        return this.http.delete(this.rutaServidor + '/api/usuarios/'+ id, this.options)
            .map(response => {
                return response.json();
             })
            .catch(this.bodyService.handleError);
    }   
    
    changePassword(changePassword: ChangePassword): Observable<ChangePassword>  {

        changePassword.claveActualAnterior = changePassword.claveActual;
        changePassword.nuevaClaveAnterior = changePassword.nuevaClave;
        changePassword.confirmarClaveAnterior = changePassword.confirmarClave;

        // changePassword.claveActual = IntegrixEncoderUtils.encriptar(changePassword.claveActual);
        // changePassword.nuevaClave = IntegrixEncoderUtils.encriptar(changePassword.nuevaClave);
        // changePassword.confirmarClave = IntegrixEncoderUtils.encriptar(changePassword.confirmarClave);

        changePassword.claveActual = changePassword.claveActual;
        changePassword.nuevaClave = changePassword.nuevaClave;
        changePassword.confirmarClave = changePassword.confirmarClave;

        let body = JSON.stringify(changePassword);

        return this.http.post(this.rutaServidor + '/api/usuarios/cambiarClave', body, this.options)
            .map(response => {
                let bodyResponse = response.json();
                if (bodyResponse) {
                  let changePasswordResponse = new ChangePassword(response.json());
                  return changePasswordResponse;
                } else {
                  return {}
                }
             })
            .catch(this.bodyService.handleError);
    }    
 
    getUserRoleGrafica(): Observable<any>  {  
        return this.http.get(this.rutaServidor + '/api/userSystems/getUserRoleGrafica', this.options)
            .map(response => {
                let pr : any = response.json();
                return pr;
             })
            .catch(this.bodyService.handleError);
    }

 }


// WEBPACK FOOTER //
// ./src/app/_seguridad/_usuario/usuario.service.ts